<template>
  <div class="basic-wrapper">
    <div class="top-box">
      <div class="search-box">
        <el-date-picker v-model="timeArr" type="daterange" value-format="yyyy-MM-dd" @change="changeDate" range-separator="" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="预约数据" class="h-100" name="1">
        <div v-if="activeName == 1" v-loading="loading1" class="bottom-box">
          <div class="other-box">
            <div class="other-box_inner">
              <div class="item">
                <span class="label">总预约人数</span>
                <span class="num">
                  <count-to :startVal="startVal" :endVal="numObj.appointCount ? numObj.appointCount : 0" :duration="duration"></count-to></span>
              </div>

              <div class="item">
                <span class="label">国内用户数</span>
                <span class="num">
                  <count-to :startVal="startVal" :endVal="numObj.chinaCount ? numObj.chinaCount : 0" :duration="duration"></count-to></span>
              </div>

              <div class="item">
                <span class="label">国外用户数</span>
                <span class="num">
                  <count-to :startVal="startVal" :endVal="numObj.boardCount ? numObj.boardCount : 0" :duration="duration"></count-to></span>
              </div>
            </div>
          </div>

          <div class="chart-wrapper">
            <div class="chart-item mb-20 mr-10">
              <h1 class="title">{{ numObj.appoint && numObj.appoint.chart01 && numObj.appoint.chart01.title}}</h1>
              <chart ref="chart1" class="chart-box" :options="options1" autoresize></chart>
            </div>
            <div class="chart-item mb-20 mr-10">
              <h1 class="title">{{numObj.appoint && numObj.appoint.chart02 && numObj.appoint.chart02.title }}</h1>
              <el-scrollbar class="mt-20" v-if="provinceData && provinceData.length">
                <div class="flex-direction_col">
                  <div class="item" v-for="(item, index) in provinceData" :key="index">
                    <div class="left">
                      <span class="num">{{ index+1 }}</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <span class="right">{{ item.percentage }}</span>
                  </div>
                </div>
              </el-scrollbar>

              <el-empty style="width: 100%;height: 100%;" v-else description="暂无数据"></el-empty>

            </div>

            <div class="chart-item mb-20">
              <h1 class="title">{{ numObj.appoint && numObj.appoint.chart03 && numObj.appoint.chart03.title }}</h1>
              <el-scrollbar class="mt-20" v-if="inProvinceData && inProvinceData.length">
                <div class="flex-direction_col">
                  <div class="item" v-for="(item, index) in inProvinceData" :key="index">
                    <div class="left">
                      <span class="num">{{ index+1 }}</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <span class="right">{{ item.percentage }}</span>
                  </div>
                </div>
              </el-scrollbar>

              <el-empty style="width: 100%;height: 100%;" v-else description="暂无数据"></el-empty>

            </div>

            <div class="chart-item mr-10">
              <h1 class="title">{{numObj.appoint && numObj.appoint.chart04 &&numObj.appoint.chart04.title}}</h1>
              <chart ref="chart2" class="chart-box" :options="options2" autoresize></chart>
            </div>

            <div class="chart-item mr-10">
              <h1 class="title">{{numObj.appoint && numObj.appoint.chart05 &&numObj.appoint.chart05.title}}</h1>
              <chart ref="chart3" class="chart-box" :options="options3" autoresize></chart>
            </div>

            <div class="chart-item">
              <h1 class="title">{{numObj.appoint && numObj.appoint.chart06 &&numObj.appoint.chart06.title}}</h1>
              <div class="chart-box">
                <div class="chart-box_item">
                  <chart ref="chart4" class="chart" :options="options4" autoresize></chart>
                  <div class="desc">
                    <span class="p1">市内用户人数</span>
                    <span class="p2">
                      <count-to :startVal="startVal" :endVal="numObj.appoint && numObj.appoint.chart06 && numObj.appoint.chart06.data[0].value || 0" :duration="duration"></count-to></span>
                  </div>
                </div>
                <div class="chart-box_item">
                  <chart ref="chart5" class="chart" :options="options5" autoresize></chart>
                  <div class="desc ml-50">
                    <span class="p1">市外用户人数</span>
                    <span class="p2">
                      <count-to :startVal="startVal" :endVal="numObj.appoint && numObj.appoint.chart06 &&numObj.appoint.chart06.data[1].value || 0" :duration="duration"></count-to></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="参观数据" class="h-100" name="2">
        <div v-if="activeName == 2" v-loading="loading1" class="bottom-box">
          <div class="other-box">
            <div class="other-box_inner">
              <div class="item">
                <span class="label">入馆参观人数</span>
                <span class="num">
                  <count-to :startVal="startVal" :endVal="numObj.enterCount ? numObj.enterCount : 0" :duration="duration"></count-to></span>
              </div>

              <div class="item">
                <span class="label">未入馆人数</span>
                <span class="num">
                  <count-to :startVal="startVal" :endVal="numObj.unenterCount ? numObj.unenterCount : 0" :duration="duration"></count-to></span>
              </div>
              <div class="item">
              </div>
            </div>
          </div>

          <div class="chart-wrapper">
            <div class="chart-item mb-20 mr-10">
              <h1 class="title">{{ numObj.enter && numObj.enter.chart01 && numObj.enter.chart01.title}}</h1>
              <chart class="chart-box" ref="chart1" :options="enterOptions1"></chart>
            </div>
            <div class="chart-item mb-20 mr-10">
              <h1 class="title">{{numObj.enter && numObj.enter.chart02 && numObj.enter.chart02.title }}</h1>
              <el-scrollbar class="mt-20" v-if="enterProvinceData && enterProvinceData.length">
                <div class="flex-direction_col">
                  <div class="item" v-for="(item, index) in enterProvinceData" :key="index">
                    <div class="left">
                      <span class="num">{{ index+1 }}</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <span class="right">{{ item.percentage }}</span>
                  </div>
                </div>
              </el-scrollbar>

              <el-empty style="width: 100%;height: 100%;" v-else description="暂无数据"></el-empty>

            </div>

            <div class="chart-item mb-20">
              <h1 class="title">{{ numObj.enter && numObj.enter.chart03 && numObj.enter.chart03.title }}</h1>
              <el-scrollbar class="mt-20" v-if="enterInProvinceData && enterInProvinceData.length">
                <div class="flex-direction_col">
                  <div class="item" v-for="(item, index) in enterInProvinceData" :key="index">
                    <div class="left">
                      <span class="num">{{ index+1 }}</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <span class="right">{{ item.percentage }}</span>
                  </div>
                </div>
              </el-scrollbar>

              <el-empty style="width: 100%;height: 100%;" v-else description="暂无数据"></el-empty>

            </div>

            <div class="chart-item mr-10">
              <h1 class="title">{{numObj.enter && numObj.enter.chart04 &&numObj.enter.chart04.title}}</h1>
              <chart ref="chart2" class="chart-box" :options="enterOptions2"></chart>
            </div>

            <div class="chart-item mr-10">
              <h1 class="title">{{numObj.enter && numObj.enter.chart05 &&numObj.enter.chart05.title}}</h1>
              <chart ref="chart3" class="chart-box" :options="enterOptions3"></chart>
            </div>

            <div class="chart-item">
              <h1 class="title">{{numObj.enter && numObj.enter.chart06 &&numObj.enter.chart06.title}}</h1>
              <div class="chart-box">
                <div class="chart-box_item">
                  <chart ref="chart4" class="chart" :options="enterOptions4"></chart>
                  <div class="desc">
                    <span class="p1">市内用户人数</span>
                    <span class="p2">
                      <count-to :startVal="startVal" :endVal="numObj.enter && numObj.enter.chart06 && numObj.enter.chart06.data[0].value || 0" :duration="duration"></count-to></span>
                  </div>
                </div>
                <div class="chart-box_item">
                  <chart ref="chart5" class="chart" :options="enterOptions5"></chart>
                  <div class="desc ml-50">
                    <span class="p1">市外用户人数</span>
                    <span class="p2">
                      <count-to :startVal="startVal" :endVal="numObj.enter && numObj.enter.chart06 &&numObj.enter.chart06.data[1].value || 0" :duration="duration"></count-to></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import countTo from 'vue-count-to'

import chart from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/bar'

import 'echarts/lib/component/title' //引入标题组件
import 'echarts/lib/component/legend' //引入图例组件
import 'echarts/lib/component/tooltip' //引入图例组件
import 'echarts/lib/component/toolbox' //引入图例组件
import 'echarts/lib/component/dataZoom' // 滚动条插件
export default {
  components: {
    chart,
    countTo
  },

  data() {
    return {
      activeName: '1',
      timeArr: [],
      startVal: 0,
      duration: 2000,
      numObj: {
        appointCount: 0,
        boardCount: 0,
        chinaCount: 0,
        appoint: null,
        enter: null,
        enterCount: 0,
        unenterCount: 0
      },
      provinceData: [],
      inProvinceData: [],

      enterProvinceData: [],
      enterInProvinceData: [],
      loading1: false,
      options1: {},
      options2: {},
      options3: {},
      options4: {},
      options5: {},
      enterOptions1: {},
      enterOptions2: {},
      enterOptions3: {},
      enterOptions4: {},
      enterOptions5: {}
    }
  },
  methods: {
    getData(date) {
      let tempArr = []
      if (date && date.length) {
        tempArr = date
      } else {
        let nowDate = this.$common.formatDateString(new Date(), 'yyyy-MM-dd')
        tempArr = [nowDate, nowDate]
      }
      this.loading1 = true
      this.numObj = {
        appointCount: 0,
        boardCount: 0,
        chinaCount: 0
      }
      this.$http
        .get('/AppointOrder/customStat', {
          startDate: tempArr[0],
          endDate: tempArr[1]
        })
        .then((res) => {
          this.loading1 = false
          if (res.success) {
            this.numObj = res.result
            if (this.activeName == '1') {
              this.provinceData = this.getProvincePer(
                this.numObj.appoint.chart02.data
              )
              this.inProvinceData = this.getProvincePer(
                this.numObj.appoint.chart03.data
              )
            } else if (this.activeName == '2') {
              this.enterProvinceData = this.getProvincePer(
                this.numObj.enter.chart02.data
              )
              this.enterInProvinceData = this.getProvincePer(
                this.numObj.enter.chart03.data
              )
            }
            this.$nextTick(() => {
              this.getChartOne()
              this.getChartTwo()
              this.getChartThree()
              this.getChartFour()
              this.getChartFifth()
            })
          }
        })
        .catch((err) => {
          this.loading1 = false
        })
    },

    handleClick(tab) {
      this.activeName = tab.name
      if (tab.name == '1') {
        this.provinceData = this.getProvincePer(
          this.numObj.appoint.chart02.data
        )
        this.inProvinceData = this.getProvincePer(
          this.numObj.appoint.chart03.data
        )
      } else if (tab.name == '2') {
        this.enterProvinceData = this.getProvincePer(
          this.numObj.enter.chart02.data
        )
        this.enterInProvinceData = this.getProvincePer(
          this.numObj.enter.chart03.data
        )
      }
      this.$nextTick(() => {
        this.getChartOne()
        this.getChartTwo()
        this.getChartThree()
        this.getChartFour()
        this.getChartFifth()
      })
    },

    changeDate(date) {
      this.getData(date)
    },
    getChartOne() {
      let title = '',
        data = []
      if (this.activeName == '1') {
        title = this.numObj.appoint.chart01.title
        data = this.numObj.appoint.chart01.data
      } else if (this.activeName == '2') {
        title = this.numObj.enter.chart01.title
        data = this.numObj.enter.chart01.data
      }
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          icon: 'circle',
          top: '45%',
          left: '48%',
          formatter: function (name) {
            // 找到对应系列的数据
            var data = option.series[0].data
            for (var i = 0; i < data.length; i++) {
              if (data[i].name == name) {
                let tempNum = data.reduce(function (sum, item) {
                    return sum + (item.value ? item.value : 0)
                  }, 0),
                  percent = 0
                if (tempNum > 0) {
                  percent =
                    Math.round(
                      ((data[i].value ? data[i].value : 0) / tempNum) * 100
                    ) + '%'
                }
                return (
                  name +
                  '    ' +
                  `{b|${percent ? percent : 0}}` +
                  `{a|${data[i].value ? data[i].value : 0}}`
                )
              }
            }
            return name
          },
          textStyle: {
            fontSize: 16,
            rich: {
              a: {
                color: '#000',
                fontSize: 16,

                padding: [0, 0, 0, 30]
              },
              b: {
                fontSize: 16,
                color: '#bbb'
              }
            }
          }
        },
        color: ['#32CD32', '#00BFFF'],
        series: [
          {
            name: title,
            type: 'pie',
            avoidLabelOverlap: false,
            center: ['25%', '50%'],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: 'white', // 间隔颜色
                borderWidth: 2 // 间隔大小
              }
            },
            data: data
          }
        ]
      }
      if (this.activeName == '1') {
        this.options1 = option
      } else if (this.activeName == '2') {
        this.enterOptions1 = option
      }
    },

    getProvincePer(arr) {
      let provinceData = arr,
        total = 0

      if (provinceData && provinceData.length) {
        total = provinceData.reduce((acc, curr) => acc + curr.value, 0)
        provinceData.forEach((item) => {
          item.percentage = ((item.value / total) * 100).toFixed(1) + '%'
        })

        return provinceData
      }
    },

    getChartTwo() {
      let title, data
      if (this.activeName == '1') {
        title = this.numObj.appoint.chart04.title
        data = this.numObj.appoint.chart04.data
      } else if (this.activeName == '2') {
        title = this.numObj.enter.chart04.title
        data = this.numObj.enter.chart04.data
      }
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          icon: 'circle',
          top: '45%',
          left: '48%',
          formatter: function (name) {
            // 找到对应系列的数据
            var data = option.series[0].data
            for (var i = 0; i < data.length; i++) {
              if (data[i].name == name) {
                let tempNum = data.reduce(function (sum, item) {
                    return sum + (item.value ? item.value : 0)
                  }, 0),
                  percent = 0
                if (tempNum > 0) {
                  percent =
                    Math.round(
                      ((data[i].value ? data[i].value : 0) / tempNum) * 100
                    ) + '%'
                }
                return (
                  name +
                  '    ' +
                  `{b|${percent ? percent : 0}}` +
                  `{a|${data[i].value ? data[i].value : 0}}`
                )
              }
            }
            return name
          },
          textStyle: {
            fontSize: 16,
            rich: {
              a: {
                color: '#000',
                fontSize: 16,

                padding: [0, 0, 0, 30]
              },
              b: {
                fontSize: 16,
                color: '#bbb'
              }
            }
          }
        },
        color: ['#32CD32', '#00BFFF'],
        series: [
          {
            name: title,
            type: 'pie',
            avoidLabelOverlap: false,
            center: ['25%', '50%'],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: 'white', // 间隔颜色
                borderWidth: 2 // 间隔大小
              }
            },
            data: data
          }
        ]
      }
      if (this.activeName == '1') {
        this.options2 = option
      } else if (this.activeName == '2') {
        this.enterOptions2 = option
      }
    },

    getChartThree() {
      let title, data
      if (this.activeName == '1') {
        title = this.numObj.appoint.chart05.title
        data = this.numObj.appoint.chart05.data
      } else if (this.activeName == '2') {
        title = this.numObj.enter.chart05.title
        data = this.numObj.enter.chart05.data
      }
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          icon: 'circle',
          top: '45%',
          left: '48%',
          formatter: function (name) {
            // 找到对应系列的数据
            var data = option.series[0].data
            for (var i = 0; i < data.length; i++) {
              if (data[i].name == name) {
                let tempNum = data.reduce(function (sum, item) {
                    return sum + (item.value ? item.value : 0)
                  }, 0),
                  percent = 0
                if (tempNum > 0) {
                  percent =
                    Math.round(
                      ((data[i].value ? data[i].value : 0) / tempNum) * 100
                    ) + '%'
                }
                return (
                  name +
                  '    ' +
                  `{b|${percent ? percent : 0}}` +
                  `{a|${data[i].value ? data[i].value : 0}}`
                )
              }
            }
            return name
          },
          textStyle: {
            fontSize: 16,
            rich: {
              a: {
                color: '#000',
                fontSize: 16,

                padding: [0, 0, 0, 30]
              },
              b: {
                fontSize: 16,
                color: '#bbb'
              }
            }
          }
        },
        color: ['#32CD32', '#00BFFF'],
        series: [
          {
            name: title,
            type: 'pie',
            avoidLabelOverlap: false,
            center: ['25%', '50%'],
            label: {
              show: false
            },
            itemStyle: {
              normal: {
                borderColor: 'white', // 间隔颜色
                borderWidth: 2 // 间隔大小
              }
            },
            data: data
          }
        ]
      }
      if (this.activeName == '1') {
        this.options3 = option
      } else if (this.activeName == '2') {
        this.enterOptions3 = option
      }
    },

    getChartFour() {
      let title, data
      if (this.activeName == '1') {
        title = this.numObj.appoint.chart06.title
        data = this.numObj.appoint.chart06.data
      } else if (this.activeName == '2') {
        title = this.numObj.enter.chart06.title
        data = this.numObj.enter.chart06.data
      }

      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          orient: 'vertical',
          type: 'plain',
          top: '5%',
          right: '90'
        },
        color: ['#00BFFF', '#D7D7D7'],
        series: [
          {
            name: title,
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['45%', '50%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#4c4a4a',
                formatter: function (name) {
                  var data = option.series[0].data
                  let tempNum
                  for (var i = 0; i < data.length; i++) {
                    tempNum = data.reduce(function (sum, item) {
                      return sum + (item.value ? item.value : 0)
                    }, 0)
                  }
                  return (
                    '{total|' +
                    data[0].name +
                    '}' +
                    '\n\r' +
                    '{active|' +
                    Math.floor(
                      (tempNum == 0 ? 0 : data[0].value / tempNum) * 100
                    ) +
                    '%' +
                    '}'
                  )
                },
                rich: {
                  total: {
                    fontSize: 14,
                    color: '#bbb'
                  },
                  active: {
                    fontSize: 16,
                    color: '#000',
                    lineHeight: 40
                  }
                }
              },
              emphasis: {
                //中间文字显示
                show: true
              }
            },
            data: data
          }
        ]
      }
      if (this.activeName == '1') {
        this.options4 = option
      } else if (this.activeName == '2') {
        this.enterOptions4 = option
      }
    },

    getChartFifth() {
      let title, data
      if (this.activeName == '1') {
        title = this.numObj.appoint.chart06.title
        data = this.numObj.appoint.chart06.data
      } else if (this.activeName == '2') {
        title = this.numObj.enter.chart06.title
        data = this.numObj.enter.chart06.data
      }

      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false,
          orient: 'vertical',
          type: 'plain',
          top: '5%',
          right: '60'
        },
        color: ['#D7D7D7', '#32CD32'],
        series: [
          {
            name: title,
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'center',
                color: '#4c4a4a',
                formatter: function (name) {
                  var data = option.series[0].data
                  let tempNum
                  for (var i = 0; i < data.length; i++) {
                    tempNum = data.reduce(function (sum, item) {
                      return sum + (item.value ? item.value : 0)
                    }, 0)
                  }
                  return (
                    '{total|' +
                    data[1].name +
                    '}' +
                    '\n\r' +
                    '{active|' +
                    Math.floor(
                      (tempNum == 0 ? 0 : data[1].value / tempNum) * 100
                    ) +
                    '%' +
                    '}'
                  )
                },
                rich: {
                  total: {
                    fontSize: 14,
                    color: '#bbb'
                  },
                  active: {
                    fontSize: 16,
                    color: '#000',
                    lineHeight: 40
                  }
                }
              },
              emphasis: {
                //中间文字显示
                show: true
              }
            },
            data: data
          }
        ]
      }
      if (this.activeName == '1') {
        this.options5 = option
      } else if (this.activeName == '2') {
        this.enterOptions5 = option
      }
    }
  },
  mounted() {
    let nowDate = this.$common.formatDateString(new Date(), 'yyyy-MM-dd')
    this.getData([nowDate, nowDate])
  }
}
</script>

<style lang="scss" scoped>
.basic-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/.el-tabs {
  height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  .el-tabs__header {
    height: 64px;
    line-height: 64px;
    position: absolute;
    top: 0;
    left: 20px;
  }
  .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
      .el-tabs__item {
        font-size: 16px;
      }
    }
  }

  /deep/.el-tabs__content {
    flex: 1;
    overflow: auto;
    .h-100 {
      display: flex;
    }
  }
}

.top-box {
  background: #fff;
  border-radius: 10px 10px 0 0;

  .search-box {
    display: flex;
    height: 64px;
    padding: 0 20px;
    justify-content: flex-end;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    border-bottom: 1px solid #ebedf2;

    .el-date-editor {
      border-radius: 0;
    }
  }
}

.bottom-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .other-box {
    background: #fff;
    padding: 30px 20px;
    margin-bottom: 20px;
    border-radius: 0 0 10px 10px;

    .other-box_inner {
      display: flex;
      justify-content: space-between;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .label {
          color: #bbb;
          font-size: 18px;
          line-height: 18px;
          margin-bottom: 10px;
        }

        .num {
          font-size: 20px;
          color: #000;
        }
      }
    }
  }
}

.chart-wrapper {
  height: 0;
  flex: 1;
  display: flex;
  flex-wrap: wrap;

  .chart-item {
    width: calc((100% - 20px) / 3);
    height: calc((100% - 20px) / 2);
    background: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: 10px;

    .title {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 0;
      padding-left: 20px;
      border-bottom: 1px solid #ebedf2;
    }

    .el-scrollbar {
      margin-bottom: 20px;
      height: 0;
      flex: 1;
    }
    .flex-direction_col {
      .item {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        font-size: 16px;
        color: #000;
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
        &:nth-child(1) {
          .left {
            .num {
              border-radius: 50%;
              background: #f1c40f;
              color: #fff;
            }
          }
        }

        &:nth-child(2) {
          .left {
            .num {
              border-radius: 50%;
              background: #bdc3c7;
              color: #fff;
            }
          }
        }

        &:nth-child(3) {
          .left {
            .num {
              border-radius: 50%;
              background: #d35400;
              color: #fff;
            }
          }
        }
        .left {
          .num {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-right: 40px;
            text-align: center;
            line-height: 24px;
          }
        }
      }
    }

    .chart-box {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;

      .chart-box_item {
        width: 0;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;

        .chart {
          width: 100%;
          height: 0;
          flex: 1;
        }

        .desc {
          margin-left: 62px;
          height: 80px;
          display: flex;
          flex-direction: column;

          .p1 {
            color: #bbb;
            font-size: 16px;
          }

          .p2 {
            color: #000;
            font-size: 20px;
          }
        }

        .ml-50 {
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
